<template>
  <div class="audio-wrap B_C11" v-if="audioFileUrl">
    <lottie
      :options="defaultOptions"
      :height="200"
      :width="300"
      v-on:animCreated="handleAnimation"
    />
    <div class="content" v-if="isPermission">
      <div class="play" :class="{'pause':isPlay}" @click="playPause()"></div>
      <!-- <div class="time-wrap S2 T5">
        <div class="icon"></div>
        <div class="time">16:58</div>
      </div>-->
      <div class="bottom-wrap S2 T3">
        <div class="current">{{currentTime}}</div>
        <div class="progress-wrap" id="box">
          <div class="progress" id="progress"></div>
          <div class="dot" id="dot">
            <div class="dot-style"></div>
          </div>
        </div>
        <div class="totle">{{totalTime}}</div>
        <!-- <div class="time-wrap">
          <div>{{currentTime}}</div>
          <div>{{totalTime}}</div>
        </div>-->
      </div>
    </div>
    <div
      class="cover-wrap"
      :class="{'no-login-wrap':!isLogin}"
      v-if="!isPermission||!isLogin"
    >
      <div class="lock-icon" v-if="isLogin"></div>
      <div
        class="subscribe-btn S8 T5"
        @click="emitBuy"
      >{{isLogin?'立即订阅':'立即登录'}}</div>
      <div class="subscribe-font S4 T1">{{isLogin?'订阅后点击播放音频':'登录后可收听完整音频'}}</div>
    </div>
    <audio id="mp3Btn">
      <source :src="audioFileUrl" type="audio/mpeg" />
    </audio>
  </div>
</template>
<script>
import animationData from '../../lottie/voice-bar.json'
import lottie from 'vue-lottie'
import util from "@/util/util";
export default {
  components: {
    lottie
  },
  props: ['audioFileUrl', 'audioLength', 'isPermission', 'isLogin'],

  data() {
    return {
      defaultOptions: { animationData: animationData, autoplay: false },
      animationSpeed: 1,
      anim: {},
      isPlay: false,
      currentTime: '00:00',
      totalTime: ''
    }
  },
  watch: {
    audioLength() {
      this.totalTime = this.transTime(this.audioLength)
    },
    audioFileUrl() {
      if (this.isPermission && this.isLogin) {
        this.playPause()
      }
    }
  },
  created() {
    // 关闭浮窗视频，避免与音频播放叠加
    util.closeFloatVideo()
    // this.anim.stop()
    this.$onResume(() => {
      console.log('onResume1')
      if (this.isPermission && this.isLogin) {
        this.playPause()
      }
    })
    this.$onPause(() => {
      if (this.isPermission && this.isLogin) {
        this.playPause()
      }
    })
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    },
    playPause() {
      var audio = document.querySelector('#mp3Btn')

      if (!audio) {
        setTimeout(this.playPause, 1000)
        return
      }

      this.currentTime = this.transTime(audio.currentTime)
      this.totalTime = this.transTime(audio.duration)
      if (!this.isPlay) {
        //如果当前是暂停状态
        util.keepScreenOn(true)
        this.isPlay = true
        audio.play() //播放
        this.anim.play()
      } else {
        //当前是播放状态
        this.isPlay = false
        audio.pause() //暂停
        this.anim.stop()
      }

      audio.ontimeupdate = () => {
        this.getTimeFun()
      }
      // eslint-disable-next-line no-debugger
      this.drawFun()
    },
    getTimeFun() {
      var audio = document.getElementById('mp3Btn')
      this.currentTime = this.transTime(audio.currentTime)
      this.totalTime = this.transTime(audio.duration)
      let processWidth = audio.currentTime / audio.duration
      document.getElementById('progress').style.width = processWidth * 100 + '%'
      document.getElementById('dot').style.left = processWidth * 100 + '%'
      if (this.currentTime >= this.totalTime) {
        this.isPlay = false
        document.getElementById('progress').style.width = 0
        document.getElementById('dot').style.left = 0
        this.anim.stop()
      }
    },
    transTime(time) {
      let duration = parseInt(time)
      let minute = parseInt(duration / 60)
      let sec = (duration % 60) + ''
      let isM0 = ':'
      if (minute === 0) {
        minute = '00'
      } else if (minute < 10) {
        minute = '0' + minute
      }
      if (sec.length === 1) {
        sec = '0' + sec
      }
      return minute + isM0 + sec
    },
    drawFun() {
      let _this = this
      setTimeout(() => {
        var audio = document.getElementById('mp3Btn')
        var oDiv1 = document.getElementById('box')
        var oDiv2 = document.getElementById('progress')
        var oDiv3 = document.getElementById('dot')
        oDiv3.addEventListener(
          'touchstart',
          ev => {
            audio.pause()
            var oDiv1W = oDiv1.offsetWidth
            var oldX = ev.targetTouches[0].clientX - oDiv3.offsetLeft
            oDiv3.addEventListener('touchmove', fnMove, false)
            oDiv3.addEventListener('touchend', fnEnd, false)

            function fnMove(ev) {
              var x = ev.targetTouches[0].clientX - oldX
              if (x >= oDiv1W) {
                x = oDiv1W
              } else if (x <= 0) {
                x = 0
              }
              oDiv3.style.left = x + 'px'
              oDiv2.style.width = x + 'px'
            }
            function fnEnd() {
              oDiv3.removeEventListener('touchend', fnEnd, false)
              oDiv3.removeEventListener('touchmove', fnMove, false)
              var oDiv2W = oDiv2.offsetWidth
              var oDuration = oDiv2W / oDiv1W
              console.log(_this, _this.isPlay, '=======')
              if (_this.isPlay) {
                audio.play()
              }
              audio.currentTime = oDuration * audio.duration
            }
          },
          false
        )
      }, 20)
    },
    emitBuy() {
      this.$emit('childGoBuy')
    }
  }
}
</script>
<style lang="scss" scoped>
.audio-wrap {
  position: relative;
  height: 388px;
  margin: 50px 30px;
  border-radius: 10px;
  .cover-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 388px;
    border-radius: 10px;
    text-align: center;
    background-color: rgba($color: #deecf7, $alpha: 0.9);
    &.no-login-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .subscribe-btn {
        background-color: #046bcc;
      }
    }
    .lock-icon {
      width: 92px;
      height: 92px;
      background: url('./images/lock.png') no-repeat;
      background-size: cover;
      margin: 78px auto 0;
    }
    .subscribe-btn {
      width: 200px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto;
      background-color: #ddbc65;
      border-radius: 10px;
    }
  }
  .bottom-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    left: 10px;
    right: 10px;
    bottom: 10px;
    position: absolute;
  }
  .progress-wrap {
    position: relative;
    flex: 1;
    // width: 506px;
    height: 8px;
    margin: 20px;
    background: #dddddd;
    border-radius: 2px;
    transform: rotate3d(0, 0, 0);
    .progress {
      position: absolute;
      left: 0;
      right: 0;
      height: 8px;
      width: 0;
      border-radius: 2px;
      background-color: #046bcc;
      transform: rotate3d(0, 0, 0);
    }
    // .dot {
    //   width: 64px;
    //   height: 64px;
    //   position: absolute;
    //   left: 0;
    //   top: -28px;
    //   // background-color: #2e7ff2;
    //   .dot-style {
    //     width: 13px;
    //     height: 13px;
    //     border-radius: 50%;
    //     position: absolute;
    //     left: 0;
    //     top: 24px;
    //     // margin: 0;
    //     background-color: #2e7ff2;
    //   }
    // }
    .dot {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: -9px;
      background-color: #046bcc;
      transform: rotate3d(0, 0, 0);

      :after {
        content: '';
        position: absolute;
        left: -20px;
        top: -20px;
        right: -20px;
        bottom: -20px;
        transform: rotate3d(0, 0, 0);
      }
    }
  }
  .time-wrap {
    display: flex;
    justify-content: space-between;
    color: #046bcc;
    font-size: 12px;
    line-height: 12px;
    margin-top: 20px;
  }
  // .time-wrap {
  //   position: absolute;
  //   bottom: 9px;
  //   right: 10px;
  //   width: 120px;
  //   height: 36px;
  //   background-color: rgba($color: #000000, $alpha: 0.5);
  //   border-radius: 18px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   .icon {
  //     width: 20px;
  //     height: 20px;
  //     background: url('./images/time.png') no-repeat;
  //     background-size: cover;
  //     margin: 0 8px 0 0;
  //   }
  // }
  .play {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 92px;
    height: 92px;
    background: url('./images/play.png') no-repeat;
    background-size: 100% 100%;
    &.pause {
      background-image: url('./images/pause.png');
    }
  }

  .content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
}
</style>